module.exports = __webpack_public_path__ + "img/img_iphone.1df32b38.png";